import React, {
  useContext,
  useState,
  useEffect,
  useLayoutEffect,
  useRef,
} from "react";

import EyeSlashIconSVG from "assets/svg/eye-slash-icon";
import { BsExclamationDiamondFill } from "react-icons/bs";
import { embedVideo } from "utils/constant";
import UserTagIconSVG from "assets/svg/user-tag-icon";
import GlobeIconSVG from "assets/svg/globe-icon";
import { isImgUrl, removePostalCode,currentLang } from "utils/utils";
import ReactPlayer from "react-player";
import _ from "lodash";
import { BsShare } from "react-icons/bs";
import Popup from "reactjs-popup";
import { gsap } from "gsap";
import AudioPlayer from "./media-button/audio-player";
import LazyImage from "./LazyImage";
import { imageSquareOrPortrait, profileTag } from "utils/utils";
import { useMilestones } from "redux/modules/milestone/hooks";
import PrivacyBadge from "components/milestonelist/privacyBadge";
import {
  JOB_ROLE,
} from "constants/options";
import CharacterLimit from "./character-limit";

import { CoverPlaceholderMilestone } from "constants/images";
import { ProfileDefaultPlaceholder } from "constants/images";
import MediaButton from "components/button/media-button";
import { useWindowDimensions } from "utils/customhooks";
import { useLocation, useHistory } from 'react-router-dom';

export function findScrollableParent(element) {
  let parent = element.parentElement;
  while (parent) {
    const style = getComputedStyle(parent);
    const overflowY = style.overflowY;
    const overflow = style.overflow;

    if (
      (overflowY === 'auto' || overflowY === 'scroll') ||
      (overflow === 'auto' || overflow === 'scroll')
    ) {
      return parent;
    }
    parent = parent.parentElement;
  }
  return window; // fallback if no scrollable parent found
}

export function scrollToElementWithOffset(target, offset = 50) {
  const scrollableParent = findScrollableParent(target);

  if (scrollableParent === window) {
    const y = target.getBoundingClientRect().top + window.pageYOffset;
    window.scrollTo({ top: y - offset, behavior: 'smooth' });
  } else {
    const parentTop = scrollableParent.getBoundingClientRect().top;
    const targetTop = target.getBoundingClientRect().top;
    const scrollPosition = scrollableParent.scrollTop + (targetTop - parentTop) - offset;
    scrollableParent.scrollTo({ top: scrollPosition, behavior: 'smooth' });
  }
}

const DetailedTagViewCard = ({
  title,
  dateNote,
  viewUrl,
  date,
  people,
  url = "",
  description,
  privacy,
  isPrivate,
  isAdultContent,
  categories=[],
  buttons = [],
  positions = [],
  platform,
  location,
  isYourProfile,
  onShare = () => {},
  onRemoveTag = () => {},
  onWatchMedia = () => {},
  onViewImage = () => {},
  handleViewPdf = () => {},
  onDecide = () => {},
  pending = false,
  hide = () => {},
  handlePopup = () => {},
  activePopup = {},
  group = null,
  setActivePopup = () => ({ group: null, index: null }),
  indexPopUp = -1,
  organizeBy = null,
  mention_names = {},
  dataId,
  profile,
  userData
}) => {

  const [showAllMedia, setShowAllMedia] = useState(false);
  const [showMoreOption, setShowMoreOption] = useState(false);
  const [showAudioPlayer, setShowAudioPlayer] = useState(false);
  const [showIndPlayer, setShowIndPlayer] = useState(null);
  const [hideMusic, setHideMusic] = useState(false);
  const [imageHeight, setImageHeight] = useState(null);
  const [imageUrl, setImageUrl] = useState(null);
  const listenRef = useRef();
  const optionRef = useRef();
  const contentRef = useRef();
  const { isMobile } = useWindowDimensions();
  const [desc, setDescription] = useState(description);
  const loc = useLocation();
  const history = useHistory();

  useEffect(() => {
    const search = new URLSearchParams(loc.search);
    const focusMiletone = search.get("focusMilestone");
    if(focusMiletone) {
      const targetId = Number(focusMiletone);
      const currentId = Number(dataId);
      if(targetId === currentId) {
        const element = document.querySelector(`[data-milestone-id="tagged-${targetId}"]`);
        // element.scrollIntoView();
        scrollToElementWithOffset(element, 120); // scroll with 50px top space
        const pathWithoutSearch = loc.pathname;
        history.replace(pathWithoutSearch);
      }
    }
  }, [loc, dataId, history]);

  const [isVisible, setIsVisible] = useState(-1);
  const { setPLayMusic } = useMilestones();
  const { http } = global.services;
  // ================== handleMedia ================================
  const handleMedia = async (media) => {
    http.post(`button-click/`, { id: media.id });

    let url = "";
    let orientation = "Landscape";
    let fileExt = "";

    if (
      media.sub_type.name === "Multiple Images" ||
      media.sub_type.name === "Single Image"
    ) {
      onViewImage(title, media, media["media"]);
    } else {
      if (media.url) {
        url = media.url;
        orientation = media?.orientation;
      } else {
        url = media["media"][0]["media"]["url"];
        orientation = media["media"][0]["media"]["orientation"];
        fileExt = media["media"][0]["media"]["file_extension"];
      }

      if (await isImgUrl(url)) {
        onViewImage(title, media, media["media"]);
      } else if (ReactPlayer.canPlay(url)) {
        onWatchMedia(title, url, orientation);
      } else if (fileExt === "pdf") {
        handleViewPdf(title, url,media["media"], media);
        hide();
      } else if (media.sub_type.name === "Link") {
        window.open(url, "_blank");
      } else {
        if (embedVideo.find((v) => url.includes(v.value)) && ReactPlayer.canPlay(url)) {
          onWatchMedia(title, url, orientation);
        } else {
          window.open(url, "_blank");
        }
      }
    }
  };
  // ================== useEffect ================================
  useEffect(() => {
    window.addEventListener(
      "scroll",
      () => {
        if (optionRef.current) {
          optionRef.current.close();
        }
      },
      true
    );
  }, [showAudioPlayer]);

  useLayoutEffect(() => {
    gsap.fromTo(
      ".milestone-item",
      {
        y: 20,
        opacity: 0,
      },
      {
        y: 0,
        opacity: 1,
      }
    );
  }, []);

  useEffect(() => {
    (async () => {
      if (!url) {
        setImageUrl(null);
        setImageHeight(300);
        return;
      }
      const res = await imageSquareOrPortrait(url);
      const element = contentRef.current;
      if (res === "portrait" && element) {
        if (element) {
          if (element.offsetHeight < 300) {
            setImageHeight(300);
          } else {
            setImageHeight(element.offsetHeight);
          }
          setImageUrl(url);
        }
      } else {
        setImageUrl(url);
      }
    })();
  }, [url]);

  useEffect(() => {
    if (!_.isEmpty(mention_names)) {
      let newDesc = profileTag(mention_names, description);
      setDescription(newDesc);
      return;
    }
    setDescription(description); 
  }, [description, mention_names]);


  return (
    <div className="milestone-item w-full bg-siteBg rounded-md mt-0 2sm:mt-4.5 3md:mt-6" data-milestone-id={"tagged-"+dataId || "no-id"} key={dataId || "no-id"}>
      <div
        className={`w-full flex flex-col 2md:flex-row space-y-0.5 2md:space-x-0.5 2md:space-y-0  ${
          imageUrl ? "min-h-300" : "min-h-300"
        }`}
      >
        {imageUrl ? (
          <div className="relative bg-white h-auto 2md:min-h-[300px] 2md:w-[300px]">
            {/* thumbnail */}
            <LazyImage
              viewUrl={viewUrl}
              source={imageUrl}
              customClassName="w-full md:max-w-[300px] h-auto 2md:max-h-[300px]"
              imageHeight={imageHeight}
              withContainer="w-full 2md:w-[300px]"
            />
          </div>
        ) : (
          <div className="relative min-h-[300px] 2md:w-[300px] flex items-center justify-center bg-[#e9e9e9]">
            <div className="w-full 2md:w-[300px] flex items-center justify-center h-full bg-[#e9e9e9]">
              <img
                src={CoverPlaceholderMilestone}
                alt="Milestone"
                className="h-[111px] w-[113px]"
              />
            </div>
          </div>
        )}
        <div
          className={`relative bg-white 
                    lg:mt-0 lg:py-4 lg:px-7.5 
                    sm:px-7 sm:pb-7 sm:pt-7
                    px-3 pb-6 pt-4 p-7 w-full ${
                      imageUrl
                        ? "width-responsive-detailed-view"
                        : "width-responsive-detailed-view-full"
                    }`}
          ref={contentRef}
        >
          {/* content */}
            <div className="flex items-center w-full h-full flex-col">
              <div className={`w-full flex-wrap md:flex-nowrap flex ${isYourProfile ? "justify-between" : "justify-end"}`}>
                {
                  isYourProfile && (
                    <div className="flex items-center justify-start mb-2">
                      <LazyImage
                        viewUrl={profile?.profile_image_webp_url??ProfileDefaultPlaceholder}
                        source={profile?.profile_image_webp_url??ProfileDefaultPlaceholder}
                        customClassName="w-6"
                        withContainer="w-6"
                      />
                      <div className="text-base ml-2">
                        <b>{profile?.profile_name}</b>
                        <span className="text-lightBlack ml-1">tagged <b>{userData?.profile?.profile_name || 'you'}</b> in a milestone</span>
                      </div>
                    </div>
                  )
                }

                <div className="flex flex-wrap gap-2 w-full 2md:w-auto justify-end">
                  {/* Pending tag: the tagged person hasn't decided yet. */}
                  {isYourProfile && pending && (
                    <>
                      <button
                        className="bg-lightPrimary text-white flex px-4 h-10 rounded-md items-center justify-center text-sm font-semibold flex-1 2md:flex-none"
                        onClick={() => onDecide(false)}>
                        Make Public
                      </button>
                      <button
                        className="bg-thBg text-lightBlack flex px-4 h-10 rounded-md items-center justify-center text-sm font-semibold flex-1 2md:flex-none"
                        onClick={() => onDecide(true)}>
                        Make Private
                      </button>
                      <button
                        className="border border-red text-red flex px-4 h-10 rounded-md items-center justify-center text-sm font-semibold flex-1 2md:flex-none"
                        onClick={onRemoveTag}>
                        Delete
                      </button>
                    </>
                  )}

                  {/* Decided tag: visibility dropdown (Public / Private / Remove). */}
                  {isYourProfile && !pending && !_.isEmpty(userData) && (
                    <Popup
                      ref={optionRef}
                      position="bottom right"
                      open={showMoreOption}
                      onClose={() => setShowMoreOption(false)}
                      arrow={false}
                      contentStyle={{ marginTop: 10, marginLeft: 5, zIndex: 9999, width: 220, padding: 0 }}
                      trigger={
                        <button className="bg-thBg flex px-4 h-10 rounded-md text-center items-center justify-center">
                          {!isPrivate ? "Public" : "Private"}{" "}
                          {!isPrivate ? (
                            <GlobeIconSVG className="ml-2 my-auto" stroke="black" />
                          ) : (
                            <EyeSlashIconSVG className="ml-2 my-auto" />
                          )}
                        </button>
                      }>
                      <div className="bg-white rounded-md shadow-lg py-1 text-sm overflow-hidden">
                        <button
                          className="w-full text-left px-4 py-2.5 hover:bg-thBg flex items-center gap-2"
                          onClick={() => {
                            onDecide(false);
                            setShowMoreOption(false);
                            optionRef.current && optionRef.current.close();
                          }}>
                          <GlobeIconSVG stroke="black" /> Public
                        </button>
                        <button
                          className="w-full text-left px-4 py-2.5 hover:bg-thBg flex items-center gap-2"
                          onClick={() => {
                            onDecide(true);
                            setShowMoreOption(false);
                            optionRef.current && optionRef.current.close();
                          }}>
                          <EyeSlashIconSVG /> Private
                        </button>
                        <button
                          className="w-full text-left px-4 py-2.5 hover:bg-thBg text-red font-medium border-t border-gray"
                          onClick={() => {
                            onRemoveTag();
                            setShowMoreOption(false);
                            optionRef.current && optionRef.current.close();
                          }}>
                          Remove from my page
                        </button>
                      </div>
                    </Popup>
                  )}

                  {/* Share: for a public decided tag (owner), or any tag a visitor sees. */}
                  {((isYourProfile && !pending && !isPrivate) || !isYourProfile) && (
                    <button className="bg-thBg w-10 h-10 rounded-md text-center" onClick={onShare}>
                      <BsShare className="m-auto" />
                    </button>
                  )}
                </div>
              </div>
              <div className="w-full">
                {/* title */}
                <div className="flex gap-4 justify-between">
                  <div className="flex items-center space-x-1 flex-wrap">
                    <p className="text-base 2sm:text-xl 3md:text-2xl text-lightBlack font-medium tracking-tighter leading-5 2sm:leading-7">
                      {title}
                    </p>
                  </div> 
                </div>

                {/* category */}
                {/* <div className="items-center space-x-5 flex-wrap mb-1 hidden 3md:flex">
                  <p className="px-1.5 py-1 3md:px-4.5 3md:py-1.5 bg-lightGreen text-white text-1xs 2sm:text-xs uppercase font-semibold rounded-md">
                    {category}
                  </p>
                </div> */}
                {/* details */}
                <div className="w-full mt-0 2sm:mt-1.5">
                  <div className="w-full text-[11px] 2sm:text-sm 3md:text-base text-darkerGray font-medium 3md:leading-[16px] flex items-center flex-wrap gap-x-3 gap-y-1">
                    <div className="item-col-lg">
                      <p>
                        {date}
                        {dateNote ? (
                          <span className="ml-1">{`(${dateNote})`}</span>
                        ) : null}
                        {/* <span className="pl-2 inline-flex items-center align-middle gap-2">
                          <PrivacyBadge
                            privacy={privacy}
                            isYourProfile={isYourProfile}
                          />
                        </span> */}
                      </p>
                    </div>
                    {isYourProfile && pending && (
                      <div className="item-col-lg">
                        <span className="text-[#D98634] flex flex-row items-center font-medium">
                          <BsExclamationDiamondFill className="mr-1.5" /> Awaiting your approval
                        </span>
                      </div>
                    )}
                    {isYourProfile && !pending && (
                      <div className="item-col-lg">
                        <PrivacyBadge
                          privacy={privacy}
                          isYourProfile={isYourProfile}
                        />
                      </div>
                    )}
                    {/* <p className="flex items-center capitalize">
                      {privacy === "public" ? (
                        <BsGlobe2 className="mr-1.5" />
                      ) : (
                        <BsExclamationDiamondFill className="mr-1.5" />
                      )}
                      {privacy}
                    </p> */}
                  
                    {isAdultContent && (
                      <div className="item-col-lg">
                        <span className="text-red flex flex-row items-center font-medium">
                          <BsExclamationDiamondFill className="mr-1.5" /> Adult Content
                        </span>
                      </div>
                    )}
                    {people && (
                       <div className="item-col-lg">
                        {/* <p className="hidden md:block">
                          <IoEllipse className="w-1 h-1" />
                        </p> */}
                        <p className="hidden md:flex items-center">
                          <UserTagIconSVG className="mr-1.5" />
                          {people}
                        </p>
                      </div>
                    )}
                    <div className="hidden 2sm:inline-flex flex-wrap gap-2">
                      {
                        categories.map((item,index)=>{
                          return(
                              <p key={index} className="px-1.5 py-1 block 3md:px-4.5 3md:py-1.5 bg-lightGreen text-white text-1xs 2sm:text-xs uppercase font-semibold rounded-md ">
                                {item[currentLang()] ||item.name}
                              </p>
                          )
                        })
                      }
                    </div> 
                  </div>
                  <div className="inline-flex flex-wrap 2sm:hidden gap-2">
                    {
                      categories.map((item,index)=>{
                        return( 
                          <p key={index.name} className="px-1.5 py-1 block  3md:px-4.5 3md:py-1.5 bg-lightGreen text-white text-1xs 2sm:text-xs uppercase font-semibold rounded-md ">
                           {item[currentLang()] || item.name}
                          </p> 
                        )
                      })
                    }
                  </div>
                </div>
                {/* Author Name and description */}
                <div className="w-full my-0 mt-1">
                  <p className="text-[13px] 2sm:text-sm 3md:text-base font-bold 3md:leading-6 mt-0 2sm:mt-1.5">
                    <span>
                      {positions
                        .map((p) => {
                          const _pos = [p.position[currentLang()]?.trim() || p.position.name?.trim()];
                          if (p.description)
                            _pos.push(removePostalCode(p.description).trim());
                          return _pos.join(" - ");
                        })
                        .join(", ")
                        .trim()}
                    </span>
                    {/* {positions.map((p, i) => (
                      <span key={i}>
                        {p.position.name}
                        {p.description && ` - ${removePostalCode(p.description)}`}
                        {i < positions.length - 1 && ", "}
                      </span>
                    ))} */}
                    <span className="break-anywhere">
                      {platform &&
                        ` (${platform}${location ? ` - ${location}` : ""})`}
                    </span>
                  </p>
                  <CharacterLimit html={desc} />
                </div>
                {/* buttons */}
                {!_.isEmpty(buttons) && (
                  <div className="w-full mt-3 flex flex-col md:grid md:grid-cols-[1fr] gap-3">
                    <div className="w-full flex flex-col md:grid md:grid-cols-[repeat(3,1fr)_90px] gap-3">
                      {buttons
                        .slice(
                          0,
                          showAllMedia ? buttons.length : !isMobile ? 3 : 2
                        )
                        .map((btn, index) => {
                          if (btn.type.name === "Listen") {
                            return (
                              <div
                                className="relative"
                                style={{ gridColumn: (index % 3) + 1 }}
                              >
                                <MediaButton
                                  key={index}
                                  buttonName={btn.label}
                                  buttonData={btn}
                                  buttonTextClass={`text-xs 2md:text-sm text-lightBlack font-semibold`}
                                  buttonRadius="6px"
                                  buttonClass={`relative rounded-md py-3 px-4 xl:px-0 border-2 border-gray bg-white hover:bg-thBg w-full h-full`}
                                  onClick={() => {
                                    setPLayMusic(btn);
                                    handlePopup();
                                    setIsVisible(buttons.id);
                                    setShowAudioPlayer((prev) => !prev);
                                    setShowIndPlayer(btn.id);
                                    http.post(`button-click/`, { id: btn.id });
                                  }}
                                />
                                {activePopup.group === group &&
                                  activePopup.index === indexPopUp &&
                                  btn.id === showIndPlayer && (
                                    <div
                                      className="absolute -bottom-[3.8rem] z-[9999] left-0 inser-0"
                                      ref={listenRef}
                                    >
                                      <AudioPlayer
                                        media={btn}
                                        hide={hideMusic}
                                        onClosePlayer={() => {
                                          setActivePopup({
                                            group: null,
                                            index: null,
                                          });
                                          setShowIndPlayer(null);
                                        }}
                                      />
                                    </div>
                                  )}
                                {organizeBy === JOB_ROLE &&
                                  btn.id === showIndPlayer && (
                                    <div
                                      className="absolute -bottom-[3.8rem] z-[9999] left-0 inser-0"
                                      ref={listenRef}
                                    >
                                      <AudioPlayer
                                        media={btn}
                                        hide={hideMusic}
                                        onClosePlayer={() => {
                                          setIsVisible(null);
                                          setShowIndPlayer(null);
                                        }}
                                      />
                                    </div>
                                  )}
                              </div>
                            );
                          }
                          return (
                            <div style={{ gridColumn: (index % 3) + 1 }}>
                              <MediaButton
                                buttonData={btn}
                                key={index}
                                buttonName={btn.label}
                                buttonTextClass={`text-xs 2md:text-sm text-lightBlack font-semibold`}
                                buttonRadius="6px"
                                buttonClass="relative rounded-md py-3 px-4   xl:px-0 border-2 border-gray bg-white bg-white hover:bg-thBg w-full h-full"
                                onClick={() => handleMedia(btn)}
                              />
                            </div>
                          );
                        })}
                      { buttons.length > (!isMobile ? 3 : 2) && (
                        <button
                          className={`rounded-md min-h-[2.875rem] md:col-start-4 md:row-start-1 md:row-span-1 ${
                            showAllMedia
                              ? "bg-lightBlack text-white"
                              : "bg-thBg"
                          }`}
                          onClick={() => setShowAllMedia(!showAllMedia)}
                        >
                          {showAllMedia ? "Hide" : `+${buttons.length - (!isMobile ? 3 : 2)}`}
                        </button>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
        </div>
      </div>
    </div>
  );
};


export { DetailedTagViewCard };
